// useAgendaGroups.js

import { useMemo } from 'react';
import { startOfDay } from 'date-fns';

import {
  compareCalendarEventItems,
  groupEventsByDateKey,
} from 'views/calendar/shared/calendarUtils';

const useAgendaGroups = (eventItems) => {
  return useMemo(() => {
    if (!Array.isArray(eventItems) || eventItems.length === 0) {
      return [];
    }

    const todayStart = startOfDay(new Date());
    const upcoming = eventItems.filter((item) => {
      const day = item?.day instanceof Date ? item.day : null;
      if (!day) return false;
      return day.getTime() >= todayStart.getTime();
    });

    if (upcoming.length === 0) {
      return [];
    }

    const map = groupEventsByDateKey(upcoming);

    return Array.from(map.entries())
      .map(([key, items]) => ({
        key,
        date: items[0].day,
        items: [...items].sort(compareCalendarEventItems),
      }))
      .sort((a, b) => a.date - b.date);
  }, [eventItems]);
};

export default useAgendaGroups;
